// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"349":"5932f107","354":"955eae98","418":"f2eebd06"}[chunkId] + ".js";
};